export default __webpack_public_path__ + "static/media/control.7f55a06a.svg";